// Adds traits related to saving or populating existing data to the parent component

import axios from 'axios';
import axiosRetry from 'axios-retry';

export default {
	created() {
		// Retry with exponential delay between each attempt if request fails
		// Tries up to 3 times by default
		axiosRetry(axios, {
			retries: 6,
			retryDelay: axiosRetry.exponentialDelay,
			retryCondition: () => {
				return true;
			},
		});
	},

	methods: {

		// Create a new resource
		post(resource, showId, data) {
			let url = `${process.env.VUE_APP_API_URL}/${resource}/${showId}`;
			return axios({
				url,
				method: 'POST',
				data,
			});
		},

		// Modify a resource
		put(resource, showId, id, data) {
			let url = `${process.env.VUE_APP_API_URL}/${resource}/${showId}/${id}`;
			return axios({
				url,
				method: 'PUT',
				data,
			});
		}
	},
};
